/* Reseller Directory - INOVATIV custom. Region highlight, search, opt-in distance. */
(function () {
  var root = document.getElementById('reseller-directory');
  if (!root) return;

  var COUNTRY_TO_SLUG = {
    US: 'north-america', CA: 'north-america',
    MX: 'latin-america', BR: 'latin-america', AR: 'latin-america', CL: 'latin-america', CO: 'latin-america',
    GB: 'europe', FR: 'europe', IT: 'europe', ES: 'europe', DE: 'europe', NL: 'europe', BE: 'europe',
    NO: 'europe', SE: 'europe', FI: 'europe', EE: 'europe', AT: 'europe', CZ: 'europe', IE: 'europe',
    CH: 'europe', DK: 'europe', PL: 'europe', PT: 'europe',
    AU: 'asia-pacific', NZ: 'asia-pacific', JP: 'asia-pacific', TW: 'asia-pacific', KR: 'asia-pacific',
    SG: 'asia-pacific', HK: 'asia-pacific', CN: 'asia-pacific', IN: 'asia-pacific',
    AE: 'middle-east', SA: 'middle-east', QA: 'middle-east', KW: 'middle-east', OM: 'middle-east', IL: 'middle-east'
  };
  var TZ_TO_SLUG = {
    America: 'north-america', Europe: 'europe', Australia: 'asia-pacific',
    Asia: 'asia-pacific', Pacific: 'asia-pacific'
  };
  var COUNTRY_CODE_TO_LABEL = {
    US: 'USA', CA: 'Canada', MX: 'Mexico', GB: 'UK', FR: 'France', IT: 'Italy',
    ES: 'Spain', DE: 'Germany', NL: 'Netherlands', BE: 'Belgium', NO: 'Norway',
    SE: 'Sweden', FI: 'Finland', EE: 'Estonia', AT: 'Austria', CZ: 'Czech Republic',
    AU: 'Australia', JP: 'Japan', TW: 'Taiwan', KR: 'South Korea', AE: 'United Arab Emirates'
  };

  var statusEl = root.querySelector('[data-rd-status]');
  var searchEl = root.querySelector('[data-rd-search]');
  var radiusEl = root.querySelector('[data-rd-radius]');
  var geoBtn = root.querySelector('[data-rd-geo]');
  var geoNote = root.querySelector('[data-rd-geo-note]');
  var nearestPanel = root.querySelector('[data-rd-nearest]');
  var nearestList = root.querySelector('[data-rd-nearest-list]');
  var emptyEl = root.querySelector('[data-rd-empty]');
  var continents = Array.prototype.slice.call(root.querySelectorAll('details[data-rd-continent]'));
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rd-card]'));
  var mapEl = document.getElementById('rd-map');
  var mapToggle = root.querySelector('[data-rd-map-toggle]');
  var map = null;
  var pendingFocus = null;
  var markersRef = [];

  function setMapVisible(visible) {
    if (!mapEl) return;
    mapEl.hidden = !visible;
    if (mapToggle) mapToggle.setAttribute('aria-checked', visible ? 'true' : 'false');
    if (visible && map) {
      setTimeout(function () { map.invalidateSize(); }, 0);
    }
  }

  if (mapToggle) {
    mapToggle.addEventListener('click', function () {
      setMapVisible(mapEl ? mapEl.hidden : false);
    });
  }

  function focusMap(countryLabel, slug) {
    if (!map) { pendingFocus = { country: countryLabel, slug: slug }; return; }
    var pts = [];
    cards.forEach(function (card) {
      var ok = false;
      if (countryLabel && card.getAttribute('data-country') === countryLabel) ok = true;
      if (!countryLabel && slug && card.getAttribute('data-continent') === slug) ok = true;
      if (!ok) return;
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      if (isFinite(lat) && isFinite(lng)) pts.push([lat, lng]);
    });
    if (!pts.length) return;
    if (countryLabel && pts.length > 3) {
      var offsetHours = -(new Date().getTimezoneOffset()) / 60;
      var approxLng = offsetHours * 15;
      var near = pts.filter(function (p) { return Math.abs(p[1] - approxLng) <= 18; });
      if (near.length === 0) near = pts.filter(function (p) { return Math.abs(p[1] - approxLng) <= 30; });
      if (near.length) pts = near;
    }
    var b = L.latLngBounds(pts);
    if (countryLabel) {
      var z = map.getBoundsZoom(b, false, L.point(40, 40));
      map.setView(b.getCenter(), Math.min(z, 9));
    } else {
      map.fitBounds(b, { padding: [40, 40], maxZoom: 6 });
    }
  }

  function initMap() {
    if (!mapEl || map || typeof window.L === 'undefined') return;
    map = L.map(mapEl, { scrollWheelZoom: false, maxZoom: 16 });
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}', {
      attribution: 'Tiles &copy; Esri',
      maxZoom: 16
    }).addTo(map);
    L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}', {
      maxZoom: 16
    }).addTo(map);
    var bounds = [];
    cards.forEach(function (card) {
      var lat = parseFloat(card.getAttribute('data-lat'));
      var lng = parseFloat(card.getAttribute('data-lng'));
      if (!isFinite(lat) || !isFinite(lng)) return;
      var premier = !!card.querySelector('.rd-badge');
      var marker = L.circleMarker([lat, lng], {
        radius: premier ? 9 : 6,
        color: '#ffffff',
        weight: 2,
        fillColor: '#F56F22',
        fillOpacity: premier ? 1 : 0.85
      }).addTo(map);
      var popup = document.createElement('div');
      var nm = document.createElement('strong');
      nm.textContent = card.querySelector('.rd-card-name').textContent;
      popup.appendChild(nm);
      if (premier) {
        var pb = document.createElement('div');
        pb.textContent = 'Premier Partner';
        pb.style.color = '#F56F22';
        pb.style.fontWeight = '600';
        pb.style.fontSize = '13px';
        popup.appendChild(pb);
      }
      var cityEl = card.querySelector('.rd-card-city');
      if (cityEl) {
        var ct = document.createElement('div');
        ct.textContent = cityEl.textContent;
        popup.appendChild(ct);
      }
      var lk = card.querySelector('.rd-card-link');
      if (lk) {
        var a = document.createElement('a');
        a.href = lk.href;
        a.target = '_blank';
        a.rel = 'noopener';
        a.textContent = lk.textContent.replace('(opens in a new tab)', '').trim();
        popup.appendChild(a);
      }
      marker.bindPopup(popup, { autoPan: false });
      marker.on('click', function () { map.panTo([lat, lng]); });
      markersRef.push({ card: card, lat: lat, lng: lng, marker: marker });
      bounds.push([lat, lng]);
    });
    if (bounds.length) map.fitBounds(bounds, { padding: [24, 24] });
    if (pendingFocus) {
      focusMap(pendingFocus.country, pendingFocus.slug);
      pendingFocus = null;
    }
    root.classList.add('rd-has-map');
  }

  root.addEventListener('click', function (e) {
    if (!map) return;
    if (e.target.closest('a')) return;
    if (e.target.closest('[data-rd-map-toggle]')) return;
    var card = e.target.closest('[data-rd-card]');
    if (!card) return;
    var lat = parseFloat(card.getAttribute('data-lat'));
    var lng = parseFloat(card.getAttribute('data-lng'));
    if (!isFinite(lat) || !isFinite(lng)) return;
    if (mapEl && mapEl.hidden) setMapVisible(true);
    map.setView([lat, lng], 13);
    var found = markersRef.filter(function (m) { return m.lat === lat && m.lng === lng; })[0];
    if (found) found.marker.openPopup();
    if (mapEl) mapEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  });

  function applyRegion(slug, label, countryLabel) {
    var target = root.querySelector('details[data-rd-continent="' + slug + '"]');
    if (!target) return false;
    continents.forEach(function (d) { d.open = false; });
    var first = continents[0];
    if (target !== first) target.parentNode.insertBefore(target, first);
    target.open = true;
    continents = Array.prototype.slice.call(root.querySelectorAll('details[data-rd-continent]'));
    if (countryLabel) {
      var groups = Array.prototype.slice.call(target.querySelectorAll('[data-rd-country]'));
      var match = groups.filter(function (g) {
        var h = g.querySelector('.rd-country-name');
        return h && h.textContent.trim() === countryLabel;
      })[0];
      if (match && groups[0] && match !== groups[0]) {
        groups[0].parentNode.insertBefore(match, groups[0]);
      }
    }
    if (statusEl && label) {
      statusEl.textContent = 'Showing resellers near ' + label;
      statusEl.hidden = false;
    }
    focusMap(countryLabel || null, slug);
    return true;
  }

  function detectRegion() {
    var params = new URLSearchParams(window.location.search);
    var override = params.get('region');
    if (override && applyRegion(override, null)) return;
    fetch('/browsing_context_suggestions.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var dv = data && data.detected_values;
        var cc = dv && dv.country && dv.country.handle;
        var name = dv && dv.country && dv.country.name;
        var slug = cc && COUNTRY_TO_SLUG[cc];
        var countryLabel = cc && COUNTRY_CODE_TO_LABEL[cc];
        if (!slug || !applyRegion(slug, name || null, countryLabel || null)) tzFallback();
      })
      .catch(tzFallback);
  }

  function tzFallback() {
    try {
      var tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
      var prefix = tz.split('/')[0];
      var slug = TZ_TO_SLUG[prefix];
      if (slug) applyRegion(slug, null);
    } catch (e) { /* neutral order stays */ }
  }

  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function formatDistance(km) {
    var useMiles = (navigator.language || '').toUpperCase().indexOf('US') !== -1;
    if (useMiles) return Math.round(km * 0.621371) + ' mi away';
    return Math.round(km) + ' km away';
  }

  function getRadiusKm() {
    if (!radiusEl || radiusEl.value === '') return Infinity;
    var mi = parseFloat(radiusEl.value);
    if (!isFinite(mi)) return Infinity;
    return mi * 1.60934;
  }

  function getRadiusLabel() {
    if (!radiusEl || radiusEl.value === '') return '';
    return radiusEl.value + ' mi';
  }

  var searchMarker = null;
  var geocodeTimer = null;
  var lastGeocodeQuery = '';
  var lastCenter = null;

  function clearSearchLocation() {
    lastGeocodeQuery = '';
    lastCenter = null;
    if (geocodeTimer) { clearTimeout(geocodeTimer); geocodeTimer = null; }
    if (searchMarker && map) { map.removeLayer(searchMarker); searchMarker = null; }
  }

  function setNearestTitle(text) {
    if (!nearestPanel) return;
    var titleEl = nearestPanel.querySelector('[data-rd-nearest-title]');
    if (titleEl) titleEl.textContent = text;
  }

  function rankNearest(lat, lng) {
    var ranked = cards.map(function (card) {
      var d = haversineKm(lat, lng, parseFloat(card.getAttribute('data-lat')), parseFloat(card.getAttribute('data-lng')));
      return { card: card, km: d };
    }).filter(function (x) { return isFinite(x.km); });
    ranked.sort(function (a, b) { return a.km - b.km; });
    return ranked;
  }

  function markerFor(card) {
    return markersRef.filter(function (m) { return m.card === card; })[0] || null;
  }

  function promotePremiers(list, capPremier) {
    var premiers = list.filter(function (x) { return !!x.card.querySelector('.rd-badge'); }).slice(0, capPremier);
    return premiers.concat(list.filter(function (x) { return premiers.indexOf(x) === -1; }));
  }

  function renderNearest(center) {
    var ranked = rankNearest(center.lat, center.lng);
    if (!ranked.length) return;
    var radiusKm = getRadiusKm();
    var radLabel = getRadiusLabel();
    var results;
    var title;
    var inRadius = false;
    if (!isFinite(radiusKm)) {
      results = promotePremiers(ranked.filter(function (x) { return x.km <= 2000; }).concat(ranked.filter(function (x) { return x.km > 2000; })).slice(0, 5), 2);
      title = center.isGeo ? 'Closest resellers to you' : 'Closest resellers to ' + center.label;
    } else {
      var within = ranked.filter(function (x) { return x.km <= radiusKm; });
      if (within.length) {
        inRadius = true;
        results = promotePremiers(within, 2).slice(0, 12);
        title = 'Resellers within ' + radLabel + ' of ' + (center.isGeo ? 'you' : center.label);
      } else {
        var premiers = ranked.filter(function (x) { return x.km <= 2000 && !!x.card.querySelector('.rd-badge'); }).slice(0, 2);
        results = premiers.concat(ranked.filter(function (x) { return premiers.indexOf(x) === -1; })).slice(0, 3);
        title = 'No resellers within ' + radLabel + (center.isGeo ? '' : ' of ' + center.label) + ' - showing the closest';
      }
    }
    if (nearestPanel && nearestList) {
      setNearestTitle(title);
      while (nearestList.firstChild) { nearestList.removeChild(nearestList.firstChild); }
      results.forEach(function (x) {
        var clone = x.card.cloneNode(true);
        clone.hidden = false;
        var distEl = clone.querySelector('[data-rd-distance]');
        if (distEl) { distEl.textContent = formatDistance(x.km); distEl.hidden = false; }
        nearestList.appendChild(clone);
      });
      nearestPanel.hidden = false;
    }
    if (emptyEl) emptyEl.hidden = true;
    if (map) {
      if (searchMarker) map.removeLayer(searchMarker);
      searchMarker = L.circleMarker([center.lat, center.lng], { radius: 7, color: '#ffffff', weight: 2, fillColor: '#2e2e2e', fillOpacity: 1 })
        .addTo(map)
        .bindPopup(center.isGeo ? 'You are here' : center.label, { autoPan: false });
      var pts = [[center.lat, center.lng]];
      results.forEach(function (x) {
        var mr = markerFor(x.card);
        if (mr && !map.hasLayer(mr.marker)) mr.marker.addTo(map);
        var lat = parseFloat(x.card.getAttribute('data-lat'));
        var lng = parseFloat(x.card.getAttribute('data-lng'));
        if (isFinite(lat) && isFinite(lng)) pts.push([lat, lng]);
      });
      var RADIUS_ZOOM = { '50': 11, '100': 10, '250': 9 };
      var rz;
      if (inRadius && radiusEl && RADIUS_ZOOM[radiusEl.value]) {
        rz = RADIUS_ZOOM[radiusEl.value];
      } else {
        var rb = L.latLngBounds(pts);
        rz = Math.min(map.getBoundsZoom(rb, false, L.point(40, 40)) + 1, 11);
      }
      map.setView([center.lat, center.lng], rz);
    }
  }

  function showNearestForPlace(lat, lng, label) {
    lastCenter = { lat: lat, lng: lng, label: label, isGeo: false };
    renderNearest(lastCenter);
  }

  function geocodeAndSuggest(query) {
    lastGeocodeQuery = query;
    fetch('https://photon.komoot.io/api/?q=' + encodeURIComponent(query) + '&limit=1')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (query !== lastGeocodeQuery) return;
        var f = data && data.features && data.features[0];
        if (!f || !f.geometry || !f.geometry.coordinates) return;
        var lng = f.geometry.coordinates[0];
        var lat = f.geometry.coordinates[1];
        var props = f.properties || {};
        var label = props.name || query;
        if (props.country && props.name) label = props.name + ', ' + props.country;
        showNearestForPlace(lat, lng, label);
      })
      .catch(function () { /* keep the plain empty state */ });
  }

  function syncMapMarkers(query) {
    if (!map) return;
    var visiblePts = [];
    markersRef.forEach(function (m) {
      if (m.card.hidden) {
        if (map.hasLayer(m.marker)) map.removeLayer(m.marker);
      } else {
        if (!map.hasLayer(m.marker)) m.marker.addTo(map);
        visiblePts.push([m.lat, m.lng]);
      }
    });
    if (query && visiblePts.length) map.fitBounds(visiblePts, { padding: [40, 40], maxZoom: 12 });
  }

  function refreshVisibility(query) {
    var visibleTotal = 0;
    continents.forEach(function (cont) {
      var contVisible = 0;
      Array.prototype.slice.call(cont.querySelectorAll('[data-rd-country]')).forEach(function (group) {
        var groupVisible = 0;
        Array.prototype.slice.call(group.querySelectorAll('[data-rd-card]')).forEach(function (card) {
          var match = !query || card.getAttribute('data-search').indexOf(query) !== -1;
          card.hidden = !match;
          if (match) groupVisible++;
        });
        group.hidden = groupVisible === 0;
        contVisible += groupVisible;
      });
      var countEl = cont.querySelector('[data-rd-count]');
      if (countEl) countEl.textContent = contVisible + (contVisible === 1 ? ' reseller' : ' resellers');
      cont.hidden = contVisible === 0;
      if (query && contVisible > 0) cont.open = true;
      visibleTotal += contVisible;
    });
    if (emptyEl) emptyEl.hidden = visibleTotal !== 0;
    syncMapMarkers(query);
  }

  function findPlaceCard(q) {
    if (q.length < 3) return null;
    for (var i = 0; i < cards.length; i++) {
      var place = cards[i].getAttribute('data-place') || '';
      if (place.indexOf(q) !== -1) return cards[i];
    }
    return null;
  }

  function handleSearch() {
    var q = searchEl.value.trim().toLowerCase();
    clearSearchLocation();
    if (nearestPanel) nearestPanel.hidden = true;
    refreshVisibility(q);
    if (!q) {
      detectRegion();
      return;
    }
    var placeCard = findPlaceCard(q);
    if (placeCard) {
      var lat = parseFloat(placeCard.getAttribute('data-lat'));
      var lng = parseFloat(placeCard.getAttribute('data-lng'));
      if (isFinite(lat) && isFinite(lng)) {
        var cityEl = placeCard.querySelector('.rd-card-city');
        var label = cityEl ? cityEl.textContent.trim() : searchEl.value.trim();
        showNearestForPlace(lat, lng, label);
        return;
      }
    }
    if (emptyEl && !emptyEl.hidden) {
      geocodeTimer = setTimeout(function () {
        geocodeAndSuggest(searchEl.value.trim());
      }, 700);
    }
  }

  if (searchEl) {
    searchEl.addEventListener('input', handleSearch);
  }

  if (radiusEl) {
    radiusEl.addEventListener('change', function () {
      if (lastCenter) {
        renderNearest(lastCenter);
      } else if (searchEl && searchEl.value.trim()) {
        handleSearch();
      }
    });
  }

  if (geoBtn) {
    geoBtn.addEventListener('click', function () {
      if (!navigator.geolocation) {
        if (geoNote) { geoNote.textContent = 'Location is not available in this browser.'; geoNote.hidden = false; }
        return;
      }
      if (searchEl && searchEl.value) {
        searchEl.value = '';
        refreshVisibility('');
      }
      clearSearchLocation();
      geoBtn.disabled = true;
      navigator.geolocation.getCurrentPosition(function (pos) {
        var lat = pos.coords.latitude;
        var lng = pos.coords.longitude;
        cards.forEach(function (card) {
          var d = haversineKm(lat, lng, parseFloat(card.getAttribute('data-lat')), parseFloat(card.getAttribute('data-lng')));
          var distEl = card.querySelector('[data-rd-distance]');
          if (distEl && isFinite(d)) { distEl.textContent = formatDistance(d); distEl.hidden = false; }
        });
        if (map && mapEl && mapEl.hidden) setMapVisible(true);
        lastCenter = { lat: lat, lng: lng, label: 'you', isGeo: true };
        renderNearest(lastCenter);
        if (nearestPanel) nearestPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        geoBtn.disabled = false;
      }, function () {
        if (geoNote) { geoNote.textContent = 'Location unavailable or declined. Showing the region view instead.'; geoNote.hidden = false; }
        geoBtn.disabled = false;
      }, { timeout: 8000 });
    });
  }

  detectRegion();
  initMap();
  window.addEventListener('load', initMap);
})();